import { api } from "..";

import { BetslipCategory, BetslipCategoryStakes } from "@/stores/Betslip";
import { Selection } from "@/types/SportsApiResponses";
import { PlayerCoupon } from "@/types/ApiResponses/Coupon";

export interface CreateCouponPayload {
  selections: Pick<Selection, "id" | "odds" | "key">[];
  category: BetslipCategory;
  stakes: BetslipCategoryStakes;
  lang: string;
  name: string;
}

export async function createCoupon(
  payload: CreateCouponPayload
): Promise<PlayerCoupon[]> {
  const res = await api.client.post("/coupon-new", payload);
  return res.data;
}
